import axios, { AxiosError } from "axios";
const SenderReceiverResource = {
    get(senderReceiverId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/sender-receivers/${senderReceiverId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(request, resultFunc, errorFunc, finallyFunc) {
        axios.post('/admin/v1/sender-receivers', request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(senderReceiverId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/sender-receivers/${senderReceiverId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default SenderReceiverResource;
